import { Switch } from '@/components/ui/switch'
import {
  useOrgConsentEnforcement,
  useUpdateOrgConsentEnforcement,
} from '@/hooks/useOrgConsentEnforcement'

export function ConsentSection() {
  const { enabled, isLoading, error } = useOrgConsentEnforcement()
  const updateMutation = useUpdateOrgConsentEnforcement()

  return (
    <div className="space-y-6">
      <div className="space-y-1.5">
        <h3 className="text-base font-semibold text-card-foreground">
          Consent enforcement
        </h3>
        <p className="text-sm text-muted-foreground">
          When this is on, a shopper in the EEA starts every chat in a limited
          state. Chat still answers their questions. Nothing is written to their
          browser, no analytics or personalization runs, and no lead is
          captured, until your consent platform tells us they agreed. UK
          shoppers are not covered.
        </p>
      </div>

      <div className="space-y-1.5">
        <h3 className="text-base font-semibold text-card-foreground">
          Connect your consent platform first
        </h3>
        <p className="text-sm text-muted-foreground">
          Your consent platform has to call our consent API when a shopper
          agrees. Turn this on without that call wired up and every EEA shopper
          stays in the limited state for their whole visit. You lose every lead
          from those shoppers, silently.
        </p>
      </div>

      {error ? (
        <p className="text-sm text-destructive">
          We could not read your current setting. Reload the page before you
          change it, so you do not switch off enforcement that is already on.
        </p>
      ) : null}

      <div className="flex items-start justify-between gap-4 rounded-2xl border border-border bg-background p-4 shadow-sm">
        <div className="space-y-0.5">
          <label
            htmlFor="consent-enforcement-enabled"
            className="text-sm font-medium text-foreground"
          >
            Require consent before tracking EEA shoppers
          </label>
          <p className="text-sm text-muted-foreground">
            Off by default. This applies to every agent in your organization.
          </p>
        </div>
        <Switch
          id="consent-enforcement-enabled"
          aria-label="Require consent before tracking EEA shoppers"
          checked={enabled}
          disabled={isLoading || !!error || updateMutation.isPending}
          onCheckedChange={(checked) => updateMutation.mutate(checked)}
        />
      </div>
    </div>
  )
}
